export const READING_PAGE_IMAGE_WIDTH = 480
export const READING_PAGE_IMAGE_HEIGHT = 300
